export default [
  {
    path: '/app/footer-contacts',
    name: 'FooterContacts',
    component: () => import('@/views/Admin/Footer_contacts/Index.vue'),
    meta: {
      pageTitle: 'İletişim',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_MODULES',
      action: 'read',
    },
  },
  {
    path: '/app/footer-contacts/edit/:id',
    name: 'FooterContactEdit',
    component: () => import('@/views/Admin/Footer_contacts/Edit.vue'),
    meta: {
      pageTitle: 'İletişim',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/footer-contacts',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_MODULES',
      action: 'read',
    },
  },
]
